<template>
  <v-app>
    <!--HEADER-->
      <header_comp/>
    <!--MAIN-->
      <v-main>
        <router-view/>
      </v-main>
    <!--FOOTER-->
      <footer_comp/>
    <!--LOADING-->
      <v-dialog
        v-model="dialogLoading"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="blue-grey darken-2"
          dark
        >
          <v-card-text>
            <div class="pt-2 text-center">Cargando</div>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    <!--MSG-->
      <v-dialog
        v-model="dialogMSG"
        persistent
        max-width="320"
      >
        <v-card>
          <v-card-title class="text-h7">
            <v-icon color="blue-grey">mdi mdi-alert</v-icon> <span class="dialog-alert blue-grey--text text--darken-2">Alerta</span>
          </v-card-title>
          <v-card-text class="pb-0"><span class="message-da">{{ msgAlert }}</span></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue-grey darken-2"
              text
              @click="closeAlert()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-app>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import header_comp from './components/Header';
import footer_comp from './components/Footer';
export default {
  name: 'App',
  methods:{
    ...mapActions(['getSlidesAsinc']),
    closeAlert(){
      this.$store.commit('dialogMSG', {flag: false, msg:""})
    }
  },
  components:{
    header_comp,
    footer_comp
  },
  computed: {
    ...mapState([
      'dialogLoading',
      'dialogMSG',
      'msgAlert'
    ])
  },
  created(){
    this.getSlidesAsinc()
  }
}
</script>
<style lang="css">
  @import './assets/styles/core.css';
</style>
